// store FormattedMessages here that will be used multiple places
import React from 'react'
import { FormattedMessage } from 'react-intl'

const email = <FormattedMessage id={'Email'} defaultMessage={'Email'} />
const password = (
  <FormattedMessage id={'Password'} defaultMessage={'Password'} />
)
const signIn = <FormattedMessage id={'SignIn'} defaultMessage={'Sign In'} />
const forgotYourPassword = (
  <FormattedMessage
    id={'ForgotYourPassword'}
    defaultMessage={'Forgot your password?'}
  />
)
const save = <FormattedMessage id={'Save'} defaultMessage={'Save'} />
const cancel = <FormattedMessage id={'Cancel'} defaultMessage={'Cancel'} />
const photo = <FormattedMessage id={'Photo'} defaultMessage={'Photo'} />
const passwordsDoNotMatch = (
  <FormattedMessage
    id={'PasswordsDoNotMatch'}
    defaultMessage={'Passwords do not match.'}
  />
)
const review = <FormattedMessage id={'Review'} defaultMessage={'Review'} />
const questDesigner = (
  <FormattedMessage id={'QuestDesigner'} defaultMessage={'Quest Designer'} />
)
const publisher = (
  <FormattedMessage id={'Publisher'} defaultMessage={'Publisher'} />
)
const internalReviewer = (
  <FormattedMessage
    id={'InternalReviewer'}
    defaultMessage={'Internal Reviewer'}
  />
)
const oeReviewer = (
  <FormattedMessage id={'OeReviewer'} defaultMessage={'Publication Reviewer'} />
)
const activity = (
  <FormattedMessage id={'Activity'} defaultMessage={' Activity'} />
)
const activities = (
  <FormattedMessage id={'Activities'} defaultMessage={' Activities'} />
)
const subtopics = (
  <FormattedMessage id={'Subtopics'} defaultMessage={'SUBTOPICS'} />
)
const need = <FormattedMessage id={'Need'} defaultMessage={'Need'} />
const needs = <FormattedMessage id={'Needs'} defaultMessage={'Needs'} />
const day = <FormattedMessage id={'Day'} defaultMessage={'day'} />
const days = <FormattedMessage id={'Days'} defaultMessage={'days'} />
const direct = <FormattedMessage id={'Direct'} defaultMessage={'Direct'} />
const supplemental = (
  <FormattedMessage id={'Supplemental'} defaultMessage={'Supplemental'} />
)
const more = <FormattedMessage id={'More'} defaultMessage="more" />
const name = <FormattedMessage id={'Name'} defaultMessage={'Name'} />
const fieldRequired = (
  <FormattedMessage
    id={'FieldRequired'}
    defaultMessage={'This field is required.'}
  />
)
const credibleResource = (
  <FormattedMessage
    id={'ActivityResource.Credible'}
    defaultMessage={
      'Is this resource credible and high-quality? For more information on selecting good resources see the '
    }
  />
)
const resourceDescriptionMessage = (
  <FormattedMessage
    id={'ActivityResource.Description'}
    defaultMessage={'Resource Description'}
  />
)
const resourceTypeMessage = (
  <FormattedMessage
    id={'ActivityResource.Type'}
    defaultMessage={'Resource Type'}
  />
)
const formatMessage = (
  <FormattedMessage id={'Format'} defaultMessage={'Format'} />
)
const link = <FormattedMessage id={'Link'} defaultMessage={'Link'} />
const fileMessage = <FormattedMessage id={'File'} defaultMessage={'File'} />
const urlMessage = <FormattedMessage id={'URL'} defaultMessage={'URL'} />
const urlInvalid = (
  <FormattedMessage
    id={'URLInvalid'}
    defaultMessage={
      'URL is invalid. Please ensure the URL contains either http:// or https://.'
    }
  />
)
const resourceFile = (
  <FormattedMessage
    id={'ActivityResource.ResourceFile'}
    defaultMessage={'Resource File'}
  />
)
const videoTypeWarning = (
  <FormattedMessage
    id={'VideoTypeWarning'}
    defaultMessage={'Videos must be .3gp, .mp4, .mkv, or .webm.'}
  />
)
const attribution = (
  <FormattedMessage id={'Attribution'} defaultMessage={'Attribution'} />
)
const attributionInsideOrg = (
  <FormattedMessage
    id={'Attribution.InsideOrg'}
    defaultMessage={'I or someone in my organization made this resource.'}
  />
)
const attributionOutsideOrg = (
  <FormattedMessage
    id={'Attribution.OutsideOrg'}
    defaultMessage={'Someone outside my organization made this resource.'}
  />
)
const copyrightHolder = (
  <FormattedMessage
    id={'CopyrightHolder'}
    defaultMessage={'Copyright Holder'}
  />
)
const license = <FormattedMessage id={'License'} defaultMessage={'License'} />
const attributionAndNoncommercial = (
  <FormattedMessage
    id={'AttributionAndNoncommercial'}
    defaultMessage={'Attribution + Noncommercial'}
  />
)
const youreDone = (
  <FormattedMessage id={'YoureDone'} defaultMessage={"You're done!"} />
)
const provideCitation = (
  <FormattedMessage
    id={'ActivityResource.ProvideCitation'}
    defaultMessage={'Provide a citation for this resource: '}
  />
)
const remove = <FormattedMessage id={'Remove'} defaultMessage={'Remove'} />
const fileDescription = (
  <FormattedMessage
    id={'FileDescription'}
    defaultMessage={'File Description'}
  />
)
const saveFile = (
  <FormattedMessage id={'SaveFile'} defaultMessage={'Save File'} />
)
const uploadedFile = (
  <FormattedMessage id={'UploadedFile'} defaultMessage={'Uploaded File '} />
)
const title = <FormattedMessage id={'Title'} defaultMessage={'Title '} />
const activityGoals = (
  <FormattedMessage id={'Activity.Goals'} defaultMessage={'Activity Goals '} />
)
const descriptionMessage = (
  <FormattedMessage id={'Description'} defaultMessage={'Description '} />
)
const yes = <FormattedMessage id={'Yes'} defaultMessage={'Yes'} />
const no = <FormattedMessage id={'No'} defaultMessage={'No'} />
const requiresArtifact = (
  <FormattedMessage
    id={'Activity.RequiresArtifact'}
    defaultMessage={'Requires Artifact?'}
  />
)
const activityResources = (
  <FormattedMessage
    id={'Activity.ActivityResources'}
    defaultMessage={'Activity Resources'}
  />
)
const addResource = (
  <FormattedMessage
    id={'ActivityEdit.AddResource'}
    defaultMessage={'Add Resource'}
  />
)
const justFor = <FormattedMessage id={'JustFor'} defaultMessage={'Just For '} />
const mentors = <FormattedMessage id={'Mentors'} defaultMessage={'MENTORS'} />
const notesForMentors = (
  <FormattedMessage
    id={'Activity.NotesForMentors'}
    defaultMessage={'Notes for Mentors'}
  />
)
const uploadFileForMentors = (
  <FormattedMessage
    id={'ActivityEdit.UploadMentorFile'}
    defaultMessage={'Upload a File For Mentors'}
  />
)
const assessmentQuestions = (
  <FormattedMessage
    id={'Activity.AssessmentQuestions'}
    defaultMessage={'Assessment Questions for Mentors'}
  />
)
const authors = <FormattedMessage id={'Authors'} defaultMessage={'Authors'} />
const tags = <FormattedMessage id={'Tags'} defaultMessage={'Tags'} />
const youMayAlsoLike = (
  <FormattedMessage
    id={'YouMayAlsoLike'}
    defaultMessage={'You May Also Like...'}
  />
)
const none = <FormattedMessage id={'None'} defaultMessage={'None'} />
const citation = (
  <FormattedMessage id={'Citation'} defaultMessage={'Citation'} />
)
const topicsAndStandards = (
  <FormattedMessage
    id={'TopicsAndStandards'}
    defaultMessage={'Topics & Standards'}
  />
)
const saved = <FormattedMessage id={'Saved'} defaultMessage={'Saved'} />
const optional = (
  <FormattedMessage id={'Optional'} defaultMessage={'Optional'} />
)
const sourceOfTheImage = (
  <FormattedMessage
    id={'SourceOfTheImage'}
    defaultMessage={'source of the image (url)'}
  />
)
const atLeastTwoActivities = (
  <FormattedMessage
    id={'Quest.NoActivities.AtLeastTwoActivities'}
    defaultMessage={'At least one activity is required to publish your quest!'}
  />
)
const addAComment = (
  <FormattedMessage id={'AddAComment'} defaultMessage={'Add A Comment'} />
)
const commentMessage = (
  <FormattedMessage id={'Comment'} defaultMessage={'Comment'} />
)
const commentsMessage = (
  <FormattedMessage id={'Comments'} defaultMessage={'Comments'} />
)
const hide = <FormattedMessage id={'Hide'} defaultMessage={'Hide'} />
const show = <FormattedMessage id={'Show'} defaultMessage={'Show'} />
const resolved = (
  <FormattedMessage id={'Resolved'} defaultMessage={'Resolved'} />
)
const complete = (
  <FormattedMessage id={'Complete'} defaultMessage={'Complete'} />
)
const incomplete = (
  <FormattedMessage id={'Incomplete'} defaultMessage={'Incomplete'} />
)
const version = <FormattedMessage id={'Version'} defaultMessage={'Version'} />
const uploadAFile = (
  <FormattedMessage
    id={'ActivityEdit.UploadAFile'}
    defaultMessage={'Upload a file '}
  />
)
const basicInformation = (
  <FormattedMessage
    id={'BasicInformation'}
    defaultMessage={'Basic Information'}
  />
)
const activitiesMessage = (
  <FormattedMessage id={'Activities'} defaultMessage={'Activities'} />
)
const otherInformation = (
  <FormattedMessage
    id={'OtherInformation'}
    defaultMessage={'Other Information'}
  />
)
const questReview = (
  <FormattedMessage id={'QuestReview'} defaultMessage={'Quest Review'} />
)
const imagesMessage = (
  <FormattedMessage id={'Images'} defaultMessage={'Images'} />
)
const artifactDescription = (
  <FormattedMessage
    id={'ActivityEdit.ArtifactDescription'}
    defaultMessage={'Artifact Description'}
  />
)
const submit = <FormattedMessage id={'Submit'} defaultMessage={'Submit'} />
const cancelReview = (
  <FormattedMessage id={'CancelReview'} defaultMessage={'Cancel Review'} />
)
const experience = (
  <FormattedMessage id={'Experience'} defaultMessage={'Experience'} />
)
const subject = <FormattedMessage id={'Subject'} defaultMessage={'Subject'} />
const copy = <FormattedMessage id={'Copy'} defaultMessage={'Copy'} />
const standards = (
  <FormattedMessage id={'Standards'} defaultMessage={'Standards'} />
)
const final = <FormattedMessage id={'Final'} defaultMessage={'Final'} />
const oeReview = (
  <FormattedMessage id={'OEReview'} defaultMessage={'Publication Review'} />
)
const beginReview = (
  <FormattedMessage id={'BeginReview'} defaultMessage={'Begin Review'} />
)
const beganThisReviewOn = (
  <FormattedMessage
    id={'BeganThisReviewOn'}
    defaultMessage={'began this review on'}
  />
)
const submitForReview = (
  <FormattedMessage
    id={'SubmitForReview'}
    defaultMessage={'Submit for Review'}
  />
)
const editQuest = (
  <FormattedMessage id={'EditQuest'} defaultMessage={'Edit Quest'} />
)
const reviews = <FormattedMessage id={'Reviews'} defaultMessage={'Reviews'} />
const hidePrevious = (
  <FormattedMessage id={'HidePrevous'} defaultMessage={'Hide Previous'} />
)
const older = <FormattedMessage id={'Older'} defaultMessage={'older'} />
const submitForReviewAgain = (
  <FormattedMessage
    id={'SubmitForReviewAgain'}
    defaultMessage={'Submit for Review Again'}
  />
)
const inProgress = (
  <FormattedMessage id={'InProgress'} defaultMessage={'In Progress'} />
)
const internalReviewInProgress = (
  <FormattedMessage
    id={'InternalReviewInProgress'}
    defaultMessage={'Internal Review in Progress'}
  />
)
const nameCantBeBlank = (
  <FormattedMessage
    id={'NameCantBeBlank'}
    defaultMessage={"Name can't be blank"}
  />
)
const approved = (
  <FormattedMessage id={'Approved'} defaultMessage={'Approved'} />
)
const approve = <FormattedMessage id={'Approve'} defaultMessage={'Approve'} />
const needsEdits = (
  <FormattedMessage id={'NeedsEdits'} defaultMessage={'Needs Edits'} />
)
const pleaseRead = (
  <FormattedMessage id={'PleaseReadThe'} defaultMessage={'Please read the '} />
)
const belowToFind = (
  <FormattedMessage
    id={'BelowToFind'}
    defaultMessage={' below to find out what this quest needs to move forward.'}
  />
)
const experienceReview = (
  <FormattedMessage id={'ExperienceReview'} defaultMessage={'experience'} />
)
const standardsReview = (
  <FormattedMessage id={'StandardsReview'} defaultMessage={'standards'} />
)
const subjectReview = (
  <FormattedMessage id={'SubjectReview'} defaultMessage={'subject'} />
)
const otherQuests = (
  <FormattedMessage id={'OtherQuests'} defaultMessage={'Other Quests'} />
)
const quests = <FormattedMessage id={'Quests'} defaultMessage={'Quests'} />
const draft = <FormattedMessage id={'Draft'} defaultMessage={'Draft'} />
const internalReview = (
  <FormattedMessage id={'InternalReview'} defaultMessage={'Internal Review'} />
)
const published = (
  <FormattedMessage id={'Published'} defaultMessage={'Published'} />
)
const search = <FormattedMessage id={'Search'} defaultMessage={'Search'} />
const decline = (
  <FormattedMessage id="Policies.Decline" defaultMessage="DECLINE" />
)
const copyEditor = (
  <FormattedMessage id="CopyEditor" defaultMessage="Copy Editor" />
)
const externalReviewer = (
  <FormattedMessage id="ExternalReviewer" defaultMessage="External Reviewer" />
)
const lastSaved = (
  <FormattedMessage id="LastSaved" defaultMessage="Last saved on" />
)
const on = <FormattedMessage id="on" defaultMessage="on" />
const edited = <FormattedMessage id="Edited" defaultMessage="(edited)" />
const primarySubject = (
  <FormattedMessage id="PrimarySubject" defaultMessage={'Primary Subject'} />
)
const inQualityReview = (
  <FormattedMessage
    id="InQualityReview"
    defaultMessage="In Publication Review"
  />
)
const reviewReturned = (
  <FormattedMessage id="ReviewReturned" defaultMessage="Review Returned" />
)
const match = <FormattedMessage id={'Match'} defaultMessage={'match'} />
const matches = <FormattedMessage id={'Matches'} defaultMessage={'matches'} />
const yourSearch = (
  <FormattedMessage id={'YourSearch'} defaultMessage={'your search'} />
)
const quest = <FormattedMessage id={'Quest'} defaultMessage={'quest'} />
const designedBy = (
  <FormattedMessage id={'DesignedBy'} defaultMessage={'Designed by'} />
)
const by = <FormattedMessage id={'By'} defaultMessage={'by'} />
const questQualityReviewGuidelines = (
  <FormattedMessage
    id={'QuestQualityReviewGuidelines'}
    defaultMessage={'Quest Publication Review Guidelines'}
  />
)
const questsNeedToBeReviewed = (
  <FormattedMessage
    id={'InternalReview.QuestsNeedToBeReviewed'}
    defaultMessage={
      'Quests need to be reviewed by members of your organization for experience, subject matter, and quality of copy before they can move forward.'
    }
  />
)
const reviewer = (
  <FormattedMessage id={'Reviewer'} defaultMessage={'Reviewer'} />
)
const send = <FormattedMessage id={'Send'} defaultMessage={'Send'} />
const assigned = (
  <FormattedMessage
    id={'AssignedThisQuest'}
    defaultMessage={'assigned this quest to'}
  />
)
const returned = (
  <FormattedMessage
    id={'ReturnedThisQuest'}
    defaultMessage={'returned this quest to'}
  />
)
const you = <FormattedMessage id={'You'} defaultMessage={'You'} />
const allQuestsAreEvaluated = (
  <FormattedMessage
    id={'AllQuestsAreEvaluated'}
    defaultMessage={'All quests are evaluated by the publication review team'}
  />
)
const afterTheInternalProcessIsComplete = (
  <FormattedMessage
    id={'AfterTheInternalProcessIsComplete'}
    defaultMessage={'after the internal process is complete'}
  />
)
const usingThe = (
  <FormattedMessage id={'UsingThe'} defaultMessage={'using the'} />
)
const ago = <FormattedMessage id={'Ago'} defaultMessage={'ago'} />
const assignedTo = (
  <FormattedMessage id={'AssignedTo'} defaultMessage={'Assigned to'} />
)
const minutesAbbr = (
  <FormattedMessage id={'MinutesAbbr'} defaultMessage={'min'} />
)
const hourAbbr = <FormattedMessage id={'HourAbbr'} defaultMessage={'hr'} />
const hoursAbbr = <FormattedMessage id={'HoursAbbr'} defaultMessage={'hrs'} />
const newest = <FormattedMessage id={'Newest'} defaultMessage={'Newest'} />
const longestWait = (
  <FormattedMessage id={'Queue.LongestWait'} defaultMessage={'Longest Wait'} />
)
const ok = <FormattedMessage id={'Ok'} defaultMessage={'OK'} />
const clickToShowPassword = (
  <FormattedMessage
    id={'ClickToShowPassword'}
    defaultMessage={'Click to show password'}
  />
)
const clickToHidePassword = (
  <FormattedMessage
    id={'ClickToHidePassword'}
    defaultMessage={'Click to hide password'}
  />
)
const returnToLogin = (
  <FormattedMessage
    id={'ForgotPassword.ReturnToLogin'}
    defaultMessage={'Return to Login'}
  />
)
const newPassword = (
  <FormattedMessage id={'NewPassword'} defaultMessage={'New Password'} />
)
const targetGradeLevel = (
  <FormattedMessage id={'TargetGradeLevel'} defaultMessage={'Target Grade'} />
)
const targetedFor = (
  <FormattedMessage id={'TargetedFor'} defaultMessage={'Targeted for'} />
)
const specificObjective = (
  <FormattedMessage
    id={'SpecificObjective'}
    defaultMessage={'Specific Objective'}
  />
)
const averageGradeLevel = (
  <FormattedMessage
    id={'AverageGradeLevel'}
    defaultMessage={'Average Grade Level'}
  />
)
const thisDataIsNotCurrentlyAvailable = (
  <FormattedMessage
    id={'ThisDataIsNotCurrentlyAvailable'}
    defaultMessage={'This data is not currently available.'}
  />
)
const primaryElementarySchool = (
  <FormattedMessage
    id={'Readability.PrimaryElementarySchool'}
    defaultMessage={'Primary/Elementary School'}
  />
)
const primaryMiddleSchool = (
  <FormattedMessage
    id={'Readability.PrimaryMiddleSchool'}
    defaultMessage={'Primary/Middle School'}
  />
)
const secondaryHighSchool = (
  <FormattedMessage
    id={'Readability.SecondaryHighSchool'}
    defaultMessage={'Secondary/High School'}
  />
)
const postsecondaryUndergraduateUniversity = (
  <FormattedMessage
    id={'Readability.PostsecondaryUndergraduateUniversity'}
    defaultMessage={'Postsecondary/Undergraduate University'}
  />
)
const collegeOrUniversityGraduateOrAbove = (
  <FormattedMessage
    id={'Readability.CollegeOrUniversityGraduateOrAbove'}
    defaultMessage={'College or University Graduate or above'}
  />
)
const negative = (
  <FormattedMessage id={'Readability.Negative'} defaultMessage={'Negative'} />
)
const neutralModeratelyNegative = (
  <FormattedMessage
    id={'Readability.NeutralModeratelyNegative'}
    defaultMessage={'Neutral (Moderately Negative)'}
  />
)
const neutralSlightlyNegative = (
  <FormattedMessage
    id={'Readability.NeutralSlightlyNegative'}
    defaultMessage={'Neutral (Slightly Negative)'}
  />
)
const neutral = (
  <FormattedMessage id={'Readability.Neutral'} defaultMessage={'Neutral'} />
)
const neutralSlightlyPositive = (
  <FormattedMessage
    id={'Readability.NeutralSlightlyPositive'}
    defaultMessage={'Neutral (Slightly Positive)'}
  />
)
const neutralModeratelyPostive = (
  <FormattedMessage
    id={'Readability.NeutralModeratelyPostive'}
    defaultMessage={'Neutral (Moderately Positive)'}
  />
)
const positive = (
  <FormattedMessage id={'Readability.Positive'} defaultMessage={'Positive'} />
)
const questGoal = (
  <FormattedMessage id={'QuestGoal'} defaultMessage={'Quest Goal'} />
)

export {
  email,
  password,
  signIn,
  forgotYourPassword,
  save,
  cancel,
  photo,
  passwordsDoNotMatch,
  review,
  questDesigner,
  publisher,
  internalReviewer,
  oeReviewer,
  activity,
  activities,
  subtopics,
  need,
  needs,
  day,
  days,
  direct,
  supplemental,
  more,
  name,
  fieldRequired,
  credibleResource,
  resourceDescriptionMessage,
  resourceTypeMessage,
  formatMessage,
  link,
  fileMessage,
  urlMessage,
  urlInvalid,
  resourceFile,
  videoTypeWarning,
  attribution,
  attributionInsideOrg,
  attributionOutsideOrg,
  copyrightHolder,
  license,
  attributionAndNoncommercial,
  youreDone,
  provideCitation,
  remove,
  fileDescription,
  saveFile,
  uploadedFile,
  title,
  activityGoals,
  descriptionMessage,
  yes,
  no,
  requiresArtifact,
  activityResources,
  addResource,
  justFor,
  mentors,
  notesForMentors,
  uploadFileForMentors,
  assessmentQuestions,
  authors,
  tags,
  youMayAlsoLike,
  none,
  citation,
  topicsAndStandards,
  saved,
  optional,
  sourceOfTheImage,
  atLeastTwoActivities,
  addAComment,
  commentMessage,
  commentsMessage,
  hide,
  show,
  resolved,
  complete,
  incomplete,
  version,
  uploadAFile,
  basicInformation,
  activitiesMessage,
  otherInformation,
  questReview,
  imagesMessage,
  artifactDescription,
  submit,
  cancelReview,
  experience,
  subject,
  copy,
  standards,
  final,
  oeReview,
  beginReview,
  beganThisReviewOn,
  submitForReview,
  editQuest,
  reviews,
  hidePrevious,
  older,
  submitForReviewAgain,
  inProgress,
  internalReviewInProgress,
  nameCantBeBlank,
  approved,
  needsEdits,
  pleaseRead,
  belowToFind,
  experienceReview,
  standardsReview,
  subjectReview,
  otherQuests,
  quests,
  draft,
  internalReview,
  published,
  search,
  decline,
  copyEditor,
  externalReviewer,
  lastSaved,
  on,
  edited,
  primarySubject,
  inQualityReview,
  reviewReturned,
  match,
  matches,
  yourSearch,
  quest,
  designedBy,
  by,
  questQualityReviewGuidelines,
  questsNeedToBeReviewed,
  approve,
  reviewer,
  send,
  assigned,
  returned,
  you,
  allQuestsAreEvaluated,
  afterTheInternalProcessIsComplete,
  usingThe,
  ago,
  assignedTo,
  minutesAbbr,
  hourAbbr,
  hoursAbbr,
  newest,
  longestWait,
  ok,
  clickToShowPassword,
  clickToHidePassword,
  returnToLogin,
  newPassword,
  targetGradeLevel,
  targetedFor,
  specificObjective,
  averageGradeLevel,
  thisDataIsNotCurrentlyAvailable,
  primaryElementarySchool,
  primaryMiddleSchool,
  secondaryHighSchool,
  postsecondaryUndergraduateUniversity,
  collegeOrUniversityGraduateOrAbove,
  negative,
  neutralModeratelyNegative,
  neutralSlightlyNegative,
  neutral,
  neutralSlightlyPositive,
  neutralModeratelyPostive,
  positive,
  questGoal
}



// WEBPACK FOOTER //
// ./src/utils/messages.js